{
    "name": "@binance/wallet",
    "description": "Official Binance Wallet Connector - A lightweight library that provides a convenient interface to Binance's Wallet REST API.",
    "version": "14.0.0",
    "main": "./dist/index.js",
    "module": "./dist/index.mjs",
    "types": "./dist/index.d.ts",
    "exports": {
        ".": {
            "require": "./dist/index.js",
            "import": "./dist/index.mjs"
        }
    },
    "scripts": {
        "prepublishOnly": "npm run build",
        "build": "npm run clean && tsdown",
        "typecheck": "tsc --noEmit",
        "clean": "rm -rf dist",
        "test": "npx jest --maxWorkers=4 --bail",
        "test:watch": "npx jest --watch",
        "format": "npx prettier --ignore-path .prettierignore --write .",
        "lint": "npx eslint '**/*.ts' --fix"
    },
    "keywords": [
        "Binance",
        "API",
        "Wallet",
        "Connector",
        "REST",
        "Trading"
    ],
    "author": "Binance",
    "license": "MIT",
    "repository": {
        "type": "git",
        "url": "https://github.com/binance/binance-connector-js.git"
    },
    "bugs": {
        "url": "https://github.com/binance/binance-connector-js/issues"
    },
    "homepage": "https://github.com/binance/binance-connector-js#readme",
    "files": [
        "dist"
    ],
    "devDependencies": {
        "@types/jest": "^29.5.4",
        "@types/node": "^20.17.24",
        "eslint": "8.57.0",
        "jest": "^29.6.4",
        "json-with-bigint": "^3.4.4",
        "prettier": "^3.3.3",
        "ts-jest": "^29.1.1",
        "ts-node": "^10.9.1",
        "tsdown": "^0.16.5",
        "typescript": "^5.7.2",
        "typescript-eslint": "^8.24.0"
    },
    "dependencies": {
        "@binance/common": "2.2.0",
        "axios": "^1.7.4"
    }
}
